import useClientTranslations from "@workspace/casino_pages/legacyLayer/client/hooks/useClientTranslations";
import useToastContext from "@workspace/casino_pages/legacyLayer/legacyUi/Toast/Context/useToastContext";
import { useCallback } from "react";
import claimNftReward from "@/actions/rewards/claimNftReward";

const useClaimNftReward = () => {
  const { showToast } = useToastContext();
  const translations = useClientTranslations([
    "reward.nft_claim_error",
    "reward.nft_claim_success",
  ]) as Record<string, string>;

  const handleClaimNftReward = useCallback(
    async (bonusOfferId: string) => {
      const claimed = await claimNftReward(bonusOfferId);
      if (!claimed) {
        showToast({
          message: translations["reward.nft_claim_error"],
          variant: "error",
          timeout: 6000,
        });
        return;
      }
      showToast({
        message: translations["reward.nft_claim_success"],
        variant: "success",
        timeout: 6000,
      });
    },
    [showToast, translations],
  );

  return { handleClaimNftReward };
};

export default useClaimNftReward;
